module.exports = new __parcel__URL__("bitget.da063d1c.png").toString();